import { DropdownOption } from "./types";

export const initialDropdownItem: DropdownOption = {
  value: "",
  text: "Odaberi",
};

export const GetDropdownItem = (
  options: DropdownOption[],
  value: any,
  placeholder?: string | null
): DropdownOption => {
  let item = options.find((i) => i.value === value);

  if (!item) {
    item = {
      ...initialDropdownItem,
      text: placeholder ?? initialDropdownItem.text,
    };
  }

  return item;
};
